let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fVvKX")).then(() => parcelRequire('hjISk'));